// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"747f5008","787":"89ab5e4d","808":"2c4cacb5"}[chunkId] + ".chunk.js";
};